export default __webpack_public_path__ + "static/media/contact-us-image.870bb6db.png";